import {
  SCA_PRE_ENROLL,
  SCA_PRE_ENROLL_RESET,
  SCA_RECIPIENT_ENROLL,
  SCA_RECIPIENT_ENROLL_RESET,
  SCA_TRIGGER_ON,
  SCA_TRIGGER_OFF,
  SCA_VERIFY_REDIRECT_PARAMS,
  SCA_VERIFY_REDIRECT_SUCCESS,
  SCA_VERIFY_REDIRECT_FAILURE,
  SCA_VERIFICATION_RESET,
} from '../constants';

const initialState = {
  loading: false,
  result: null,
  error: null,
  preEnroll: false,
  recipientEnroll: false,
  triggerOn: false,
  actionUrl: null,
  rid: null,
};

export default function scaVerificationReducer(state = initialState, action) {
  switch (action.type) {
    case SCA_PRE_ENROLL:
      return {
        ...state,
        loading: false,
        result: null,
        error: null,
        preEnroll: true,
      };
    case SCA_PRE_ENROLL_RESET:
      return {
        ...state,
        preEnroll: false,
      };
    case SCA_RECIPIENT_ENROLL:
      return {
        ...state,
        loading: false,
        result: null,
        error: null,
        recipientEnroll: true,
        actionUrl: action.payload?.actionUrl || null,
        rid: action.payload?.rid || null,
      };
    case SCA_RECIPIENT_ENROLL_RESET:
      return {
        ...state,
        recipientEnroll: false,
      };
    case SCA_TRIGGER_ON:
      return {
        ...state,
        triggerOn: true,
      };
    case SCA_TRIGGER_OFF:
      return {
        ...state,
        triggerOn: false,
      };
    case SCA_VERIFY_REDIRECT_PARAMS:
      return {
        ...state,
        loading: true,
        result: null,
        error: null,
      };
    case SCA_VERIFY_REDIRECT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case SCA_VERIFY_REDIRECT_FAILURE:
      return {
        ...state,
        loading: false,
        result: action.payload.result || null,
        error: action.payload.message || 'Unknown error',
      };
    case SCA_VERIFICATION_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
